var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('br'),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }